var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-app-bar",
        { attrs: { app: "", color: "primary", dark: "", elevation: "2" } },
        [
          _c("v-toolbar-title", { staticClass: "d-flex align-center" }, [
            _c("img", {
              staticClass: "mr-2",
              attrs: { src: "/assets/logo.png", alt: "DriveAdv", height: "40" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text-h5 font-weight-bold" }, [
              _vm._v("DriveAdv"),
            ]),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.isAuthenticated
            ? [
                _vm.canViewChannels
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: { text: "", to: { name: "Channels" } },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-television"),
                        ]),
                        _vm._v("\n        Channels\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canViewCampaigns
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: { text: "", to: { name: "Campaigns" } },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-bullhorn"),
                        ]),
                        _vm._v("\n        Campaigns\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: { text: "", to: { name: "Users" } },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-account-multiple"),
                        ]),
                        _vm._v("\n        Users\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("v-divider", {
                  staticClass: "mx-2",
                  attrs: { vertical: "" },
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  { attrs: { text: "" }, on: { click: _vm.logout } },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-logout"),
                    ]),
                    _vm._v("\n        Logout\n      "),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-main", [_c("router-view")], 1),
      _vm._v(" "),
      _c(
        "v-footer",
        { attrs: { app: "", color: "grey lighten-4", elevation: "2" } },
        [
          _c("v-col", { staticClass: "text-center", attrs: { cols: "12" } }, [
            _c("span", { staticClass: "grey--text text--darken-1" }, [
              _vm._v(
                "\n        © " +
                  _vm._s(new Date().getFullYear()) +
                  " DriveAdv Admin UI v2.0\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }